import { createContext, useState, useContext, useEffect } from "react";

const CategoriesContext = createContext();

export const useCategories = () => useContext(CategoriesContext);

export const CategoriesProvider = ({ children }) => {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const loadCategories = async () => {
            try {
                const res = await fetch(`${import.meta.env.REACT_APP_CMS_URL}/items/categories`);
                if (!res.ok) throw new Error('Failed to load categories');
                const result = await res.json()
                setCategories(result.data)
                return;
            } catch (e) {
                alert(e)
            }
        }
        loadCategories()
    },[])

    return (
        <CategoriesContext.Provider value={{ categories }}>
            {children}
        </CategoriesContext.Provider>
    )
}